export default function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-ga/dist/esm/utils/removeLeadingSlash.js
// module id = 1041
// module chunks = 0